<template>
  <InnerPageLayout>
    <HandlerAccessDenied :is-denied="isDenied">
      <TopAdsCabinetPanel
        :isLoading="isLoading"
        :isButtonDisabled="isButtonDenied"
        @createAdsCabinet="createAdsCabinet"
      ></TopAdsCabinetPanel>
      <div class="form-container">
        <AdsCabinetCreateForm
          :isLoading="isLoading"
          @set-loading="setLoading"
          ref="createFormRef"
        ></AdsCabinetCreateForm>
      </div>
    </HandlerAccessDenied>
  </InnerPageLayout>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopAdsCabinetPanel from "@/entities/dictionaries/ads_cabinets/panels/TopAdsCabinetPanel.vue";
import AdsCabinetCreateForm from "@/entities/dictionaries/ads_cabinets/forms/AdsCabinetCreateForm.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";

const isLoading = ref(false);
const createFormRef = ref(null);
const authStore = useAuthStore();

const createAdsCabinet = () => {
  if (createFormRef.value) createFormRef.value.createAdsCabinet();
};

const setLoading = (value: boolean) => {
  isLoading.value = value;
};

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["dictionaries:read", "dictionaries:edit"]
  );
});

const isButtonDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:edit"],
    ["dictionaries:edit"]
  );
});
</script>

<style lang="scss" scoped>
.form-container {
  position: relative;
  top: 77px;
  width: calc(100% - 316px);
}
</style>
